import api, { fisgApi } from "@/api";
import store from '@/store/store.js'

// Token Refresh
let isAlreadyFetchingAccessToken = false

export default {
  init () {
    const apis = [api, fisgApi];

    apis.forEach((apiObj) => {
      apiObj.interceptors.request.use((config) => {
        const token = store.getters['auth/accessToken'];
        config.headers.Authorization = token ? `Bearer ${token}` : '';
  
        return config;
      });
  
      apiObj.interceptors.response.use(function (response) {
        return response
      }, async function (error) {
        const { config, response } = error
        const originalRequest = config
  
        if (response
          && response.status === 401
          && !isAlreadyFetchingAccessToken) {
  
          isAlreadyFetchingAccessToken = true;
          const token = await store.dispatch("auth/fetchAccessToken");
          isAlreadyFetchingAccessToken = false;
  
          apiObj.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          originalRequest.headers.Authorization = `Bearer ${token}`;
  
          return apiObj.request(originalRequest);
        }
  
        return Promise.reject(error)
      })
    });
  },
}
